var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('el-container',[_c('el-header',[_c('div',[_c('h1',[_vm._v(" Freebeat Dashboard Demo ")])])]),_c('el-container',[_c('el-aside',{attrs:{"width":"240px"}},[_c('Menu')],1),_c('el-container',[_c('el-main',[_c('router-view')],1)],1)],1),_c('el-footer',[_vm._v(" Freebeat Dashboard Demo ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }